import { useSyncExternalStore } from "react";

/** F33 (W51): Band oben in der App bei spaetem Speicherfehler. Ein Eintrag je Pfad (pathname plus search beim Start des
 *  Sicherns), in der Reihenfolge der Fehler. Der Zustand lebt nur im Speicher des Tabs (keine Daten des Haushalts im
 *  Browser-Speicher); Abmelden oder ein anderer Nutzer leeren ihn. */
export type BandEintrag = { zu: string; wort: string };

let pfade: string[] = [];
let nutzer: string | null = null;
let stand: BandEintrag[] = [];
const hoerer = new Set<() => void>();

/** Wort des Links zurueck je Pfad (Pfade aus App.tsx) */
export function wegWort(zu: string): string {
  const pfad = zu.split(/[?#]/)[0] ?? "";
  if (pfad.startsWith("/dokument/")) return "Zum Brief";
  if (pfad.startsWith("/akten/")) return "Zur Akte";
  if (pfad === "/akten") return "Zu den Akten";
  if (pfad.startsWith("/blaettern")) return "Zum Archiv";
  if (pfad === "/haushalt") return "Zum Haushalt";
  if (pfad === "/einstellungen") return "Zu den Einstellungen";
  if (pfad === "/post-per-mail") return "Zu Post per Mail";
  if (pfad === "/konto") return "Zu Daten und Konto";
  if (pfad === "/") return "Zum Posteingang";
  return "Zurück";
}

function aendern(neu: string[]) {
  pfade = neu;
  // gleiche Woerter bekommen „ 1“, „ 2“ angehaengt, damit jeder Link einen eigenen Namen hat
  const woerter = pfade.map(wegWort);
  const gezaehlt = new Map<string, number>();
  stand = pfade.map((zu, i) => {
    const wort = woerter[i] ?? "";
    if (woerter.filter((w) => w === wort).length < 2) return { zu, wort };
    const n = (gezaehlt.get(wort) ?? 0) + 1;
    gezaehlt.set(wort, n);
    return { zu, wort: `${wort} ${n}` };
  });
  for (const h of hoerer) h();
}

export function bandMelden(zu: string): void {
  if (!pfade.includes(zu)) aendern([...pfade, zu]);
}

export function bandErledigt(zu: string): void {
  if (pfade.includes(zu)) aendern(pfade.filter((p) => p !== zu));
}

export function bandLeeren(): void {
  if (pfade.length) aendern([]);
}

/** Aus der Beobachtung von „ich“ (main.tsx): abgemeldet oder ein anderer Nutzer leert das Band. */
export function bandFuerNutzer(id: string | null): void {
  if (id === null || (nutzer !== null && id !== nutzer)) bandLeeren();
  nutzer = id;
}

/** Stand ohne React (Tests, Fehlersuche) */
export function bandEintraege(): BandEintrag[] {
  return stand;
}

function abonnieren(h: () => void) {
  hoerer.add(h);
  return () => hoerer.delete(h);
}

export function useBand(): BandEintrag[] {
  return useSyncExternalStore(
    abonnieren,
    bandEintraege,
    bandEintraege,
  );
}
